import { useMediaQuery } from '@vueuse/core'

import { PHONE_MEDIA } from '~/scopes/campaign/const/config.const'

// The phone↔tablet seam (<768, see TABLET_MIN_WIDTH). Below it the panels present
// as bottom sheets (drag, pill); at 768 and up they become left rails. This is the
// gate for the drag affordance, the impacts "always expanded" rule, the map's
// gesture-to-dismiss, and the mobile camera branch — so all agree on "phone".
//
// Returns the raw media-query ref (false on the server / first client render).
// Callers that gate rendered output must guard with a mounted flag (hydration).
export function useIsPhone() {
  return useMediaQuery(PHONE_MEDIA)
}
